(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3427],{

/***/ 78493:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/thong-ke-theo-luot-truy-cap",
      function () {
        return __webpack_require__(50195);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppPage; }
});

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 2 modules
var redux = __webpack_require__(89569);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@common/core/AppLayout/Layouts.js + 155 modules
var Layouts = __webpack_require__(84175);
// EXTERNAL MODULE: ./src/@common/utility/AppContextProvider/LayoutContextProvider.js
var LayoutContextProvider = __webpack_require__(38638);
// EXTERNAL MODULE: ./src/@common/utility/AppContextProvider/SidebarContextProvider.js
var SidebarContextProvider = __webpack_require__(88748);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/shared/constants/AppEnums.js
var AppEnums = __webpack_require__(92446);
;// CONCATENATED MODULE: ./src/@common/hoc/AppPage/withLayout.js








var withLayout = function(ComposedComponent) {
    return function(props) {
        var navStyle = (0,LayoutContextProvider/* useLayoutContext */.l5)().navStyle;
        var AppLayout = Layouts/* default */.Z[navStyle];
        var updateNavStyle = (0,LayoutContextProvider/* useLayoutActionsContext */.au)().updateNavStyle;
        var ref = (0,SidebarContextProvider/* useSidebarActionsContext */.Lf)(), updateMenuStyle = ref.updateMenuStyle, setSidebarBgImage = ref.setSidebarBgImage;
        var router = (0,next_router.useRouter)();
        (0,react.useEffect)(function() {
            updateNavStyle(AppEnums/* NavStyle.MINI_SIDEBAR_TOGGLE */.Dt.MINI_SIDEBAR_TOGGLE);
            if (router.query.menuStyle) updateMenuStyle(router.query.menuStyle);
            if (router.query.sidebarImage) setSidebarBgImage(true);
        }, []);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposedComponent, (0,_object_spread/* default */.Z)({}, props))
        });
    };
};
/* harmony default export */ var AppPage_withLayout = (withLayout);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/@common/core/AppLoader/index.js
var AppLoader = __webpack_require__(74041);
// EXTERNAL MODULE: ./src/@common/utility/AuthHooks.js + 1 modules
var AuthHooks = __webpack_require__(35794);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/@common/utility/hooks/useSession.js
var useSession = __webpack_require__(2485);
// EXTERNAL MODULE: ./src/@common/index.js + 23 modules
var _common = __webpack_require__(84247);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/guards/StaffGuard.js






// ----------------------------------------------------------------------
StaffGuard.propTypes = {
    children: (prop_types_default()).node
};
function StaffGuard(param) {
    var children = param.children;
    var ref = (0,es/* useSelector */.v9)(function(param) {
        var authentication = param.authentication;
        return authentication;
    }), user = ref.user, isSuperAdmin = ref.isSuperAdmin;
    (0,react.useEffect)(function() {
        if (!user.isNhanVien) {
            if (!isSuperAdmin) {
                router_default().push("/404");
            }
        }
    }, [
        user,
        isSuperAdmin
    ]);
    return user.isNhanVien || isSuperAdmin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(_common/* AppLoader */.QP, {});
};

// EXTERNAL MODULE: ./src/redux/actions/index.js + 2 modules
var actions = __webpack_require__(84595);
;// CONCATENATED MODULE: ./src/@common/hoc/AppPage/withData.js











var withData = function(ComposedComponent) {
    return function(props) {
        var dispatch = (0,es/* useDispatch */.I0)();
        var isLoading = (0,AuthHooks/* useAuthUser */.f)().isLoading;
        var asPath = (0,next_router.useRouter)().asPath;
        var queryParams = asPath.split("?")[1];
        var ref = (0,es/* useSelector */.v9)(function(param) {
            var authentication = param.authentication;
            return authentication;
        }), isAuthenticated = ref.isAuthenticated, accessToken = ref.accessToken, user = ref.user, rememberMe = ref.rememberMe;
        var ref1 = (0,_sliced_to_array/* default */.Z)((0,useSession/* default */.Z)("rememberMe"), 1), value = ref1[0];
        var logout = (0,AuthHooks/* useAuthMethod */.a)().logout;
        (0,react.useEffect)(function() {
            dispatch((0,actions/* toggleNavCollapsedHide */.Eh)());
            if (!user && !isLoading || !accessToken || !isAuthenticated || value === undefined && (rememberMe === false || rememberMe === null)) {
                logout();
                router_default().push("/dang-nhap" + (queryParams ? "?" + queryParams : ""));
            }
        }, [
            user,
            isLoading,
            isAuthenticated,
            accessToken
        ]);
        if (!user || isLoading || !accessToken || !isAuthenticated) return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLoader/* default */.Z, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StaffGuard, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposedComponent, (0,_object_spread/* default */.Z)({}, props))
        });
    };
};
/* harmony default export */ var AppPage_withData = (withData);

;// CONCATENATED MODULE: ./src/@common/hoc/AppPage/index.js



/* harmony default export */ var AppPage = ((0,redux/* compose */.qC)(AppPage_withData, AppPage_withLayout));


/***/ }),

/***/ 50195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_hoc_AppPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60463);
/* harmony import */ var _common_utility_asyncComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31691);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




var EvlReportByAccess = (0,_common_utility_asyncComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(4231), __webpack_require__.e(9521), __webpack_require__.e(7477), __webpack_require__.e(3908), __webpack_require__.e(6602), __webpack_require__.e(5808), __webpack_require__.e(1170), __webpack_require__.e(7095), __webpack_require__.e(2377), __webpack_require__.e(1845), __webpack_require__.e(6395), __webpack_require__.e(1204), __webpack_require__.e(2816)]).then(__webpack_require__.bind(__webpack_require__, 62816));
});
/* harmony default export */ __webpack_exports__["default"] = ((0,_common_hoc_AppPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EvlReportByAccess, {});
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,4617,3874,4614,3376,9774,2888,179], function() { return __webpack_exec__(78493); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);